module.exports = __webpack_public_path__ + "media/images/chrome-logo-66fea134246b25698d1c02e42ec2ba60.png";